import { CloseIcon } from '@chakra-ui/icons';
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

export interface MtPriceProps {
  isOpen: boolean;
  url: string;
  onClose: () => void;
}

export default function ExternalLink(props: MtPriceProps) {
  const { isOpen, url, onClose } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent w="100%" h="100%" maxW={'768px'} p={0} m={0} display="flex">
        <ModalHeader p={0} m={0}>
          <Box
            display="flex"
            zIndex={1000}
            position={'relative'}
            height={'50px'}
            mr="25px"
            justifyContent={'flex-end'}
            alignItems={'flex-end'}>
            <CloseIcon
              position="relative"
              cursor={'pointer'}
              onClick={onClose}
            />
          </Box>
        </ModalHeader>

        {/* <ModalCloseButton size={"lg"} /> */}
        <ModalBody p={0} w="100%" flex={1}>
          <div
            style={{
              width: '100%',
              height: '100%',
            }}
            dangerouslySetInnerHTML={{
              __html: `<iframe src="${url}" width="100%" height="100%"></iframe> `,
            }}></div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
